import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { UserRole } from '../roles';

/**
 * SupportRouter Component
 *
 * Redirects users to their role-specific support page:
 * - Trainee → /trainee/support
 * - Admin → /admin/support
 * - Trainer → /trainer/support
 * - Super Admin → /superadmin/support
 */
const SupportRouter: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) {
      console.log('⚠️ SupportRouter: No user found, redirecting to login');
      navigate('/login');
      return;
    }

    console.log('📞 SupportRouter: Current user role:', user?.role);

    // Redirect based on user role
    switch (user?.role) {
      case UserRole.TRAINEE:
        console.log('📞 SupportRouter: Redirecting to Trainee Support Page');
        navigate('/trainee/support', { replace: true });
        break;

      case UserRole.ADMIN:
        console.log('📞 SupportRouter: Redirecting to Admin Support Page');
        navigate('/admin/support', { replace: true });
        break;

      case UserRole.TRAINER:
        console.log('📞 SupportRouter: Redirecting to Trainer Support Page');
        navigate('/trainer/support', { replace: true });
        break;

      case UserRole.SUPER_ADMIN:
        console.log('📞 SupportRouter: Redirecting to Super Admin Support Page');
        navigate('/superadmin/support', { replace: true });
        break;

      default:
        console.log('⚠️ SupportRouter: Unknown role, redirecting to login');
        navigate('/login');
        break;
    }
  }, [user, navigate]);

  // Show loading state while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'var(--color-background, #ffffff)',
      color: 'var(--color-text-primary, #1f2937)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #e5e7eb',
          borderTopColor: '#FEB901',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ fontSize: '14px' }}>Loading Support...</p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default SupportRouter;
